import React from 'react'
import { Input } from 'antd'
import './search.less'

interface Props {
  module: string
}
const SearchBar: React.FC<Props> = ({ module }) => {
  const getModuleName = () => {
    switch (module) {
      case 'Course Center':
        return '课程中心'
      case 'Resource Center':
        return '资源中心'
      case 'AI Tools':
        return 'AI备课'
      case 'News Center':
        return '信息中心'
      case 'User Center':
        return '个人中心'
      default:
        return '师资培训'
    }
  }

  return (
    <>
      <div className="course-banner">
        <div className="course-search-group">
          <div className="module-title-group">
            <div className="module-title-cn title bold">{getModuleName()}</div>
            <div className="module-title-en small">{module}</div>
          </div>
          <div className="course-search hide">
            <Input.Search
              placeholder="搜索资源"
              enterButton
              size="large"
              className="course-search-inner"
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default SearchBar
